module.exports = "<nv-react-component component=\"RolePlaySubmission\"></nv-react-component>";